var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModernPenta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.6,44.1c-5.1,0-9.8,2-13.4,5.5l-6,6h-2l-7.4-7.4c-2-2-5.2-2-7.2-0.1L71.4,66.4h14.5L96.3,56l4.7,4.7 c0.1,0.1,0.1,0.1,0.2,0.2l-3.3,3.3C94.7,67.2,90.5,69,86,69H51.4v2.2h21.7l9.9,9.9L72.7,91.4c-1.1,1.1-1.1,3,0,4.1 c1.1,1.1,3,1.1,4.1,0l12.4-12.4c1.1-1.1,1.1-3,0-4.1l-7.8-7.8H86c5.1,0,9.8-2,13.4-5.5l4.1-4.1h12.7c1.6,0,2.9-1.3,2.9-2.9 c0-1.6-1.3-2.9-2.9-2.9h-6.9l4.5-4.5c3.2-3.2,7.4-4.9,11.8-4.9h8.5v20.1h2.2V44.1H125.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 42.5,
    r: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125,25.8c-0.9,0.6-1.6,1.1-2.9,1.2c0.9-1.2,0.9-2.8-0.2-3.9c-0.6-0.6-1.3-0.9-2.1-0.9H97.7L83.9,8.6 c-1-1-2.6-1.2-3.7-0.3l-9.6,6.7c-1.3,0.9-1.7,2.8-0.7,4.1s2.8,1.7,4.1,0.7l7.6-5.3l4.4,4.4l-9.2,6.4c-0.3,0.2-0.6,0.4-0.9,0.6 c-1,0.7-1.8,1.3-3.5,1.3c-1.7,0-2.5-0.6-3.5-1.3c-1.1-0.8-2.3-1.7-4.7-1.7v2.2c1.7,0,2.5,0.6,3.5,1.3c1.1,0.8,2.3,1.7,4.7,1.7 s3.6-0.9,4.7-1.7c1-0.7,1.8-1.3,3.5-1.3s2.5,0.6,3.5,1.3c1.1,0.8,2.3,1.7,4.7,1.7s3.6-0.9,4.7-1.7c1-0.7,1.8-1.3,3.5-1.3 s2.5,0.6,3.5,1.3c1.1,0.8,2.3,1.7,4.7,1.7s3.6-0.9,4.7-1.7c1-0.7,1.8-1.3,3.5-1.3c1.7,0,2.5,0.6,3.5,1.3c1.1,0.8,2.3,1.7,4.7,1.7 c2.4,0,3.6-0.9,4.7-1.7c1-0.7,1.8-1.3,3.5-1.3v-2.2C127.3,24.2,126.1,25.1,125,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,17.5c2-2,2-5.3,0-7.3s-5.3-2-7.3,0c-2,2-2,5.3,0,7.3C98.9,19.5,102.2,19.5,104.2,17.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100.3,
    cy: 87.4,
    r: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,92.6c-1.6,0-2.9,1.3-2.9,2.9h-26.1c-2.8,0-5.1,2.3-5.1,5.1V119h13.2v-17.6h21c1.6,0,2.9-1.3,2.9-2.9 c0-1.6-1.3-2.9-2.9-2.9h9.5v-2.9L129.4,92.6L129.4,92.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.1,
    y: 122,
    width: 5.9,
    height: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121,144 108.3,122 101.5,122 114.2,144  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,41c-1.3,1.3-1.9,3-1.9,4.7v16.9L6,74.1c-1.2,1.2-1.2,3,0,4.1c1.2,1.2,3,1.2,4.1,0l11.6-11.6h16.4 c0.7,0,1.5-0.3,2.1-0.9c1.2-1.2,1.2-3,0-4.1L19.5,41z M31,60.8h-7.6v-7.6L31,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,40.7H65.6C65.1,38,62.7,36,59.9,36h-1.3v2.9h-8.4L30.5,19.2c-0.5-0.5-1.3-0.9-2.1-0.9H16.7c-1.6,0-2.9,1.3-2.9,2.9 c0,1.6,1.3,2.9,2.9,2.9h10.5l4.5,4.5L21.6,38.9l9.3,9.3l10.1-10.1l5.8,5.8c0.6,0.6,1.3,0.9,2.1,0.9h9.6v2.9l1.3,0 c2.8,0,5.2-2,5.7-4.7h18.2L83.8,40.7L83.8,40.7z M60.8,45.3v-6.9c1.5,0.4,2.6,1.8,2.6,3.4C63.4,43.5,62.3,44.9,60.8,45.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.1,
    cy: 23.5,
    r: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.2,108.6L6,133.9c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.7,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9l9.9-9.9 h23.6c0.7,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1s-0.3-1.5-0.9-2.1L31.2,108.6z M31.2,116.9l5.4,5.4H25.9L31.2,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1,100.1c-1.1-1.1-3-1.1-4.1,0l-5.2,5.2L42.3,86.8C41.7,86.3,41,86,40.2,86c-0.8,0-1.5,0.3-2.1,0.9l-8.3,8.3 c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.5,0.5,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9l6.2-6.2l3.3,3.3l-10.2,10.2 l9.3,9.3l10.2-10.2l5.8,5.8c1.1,1.1,3,1.1,4.1,0l7.3-7.3C71.2,103.1,71.2,101.2,70.1,100.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 91.3,
    r: 5.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernPenta);
export default __webpack_public_path__ + "static/media/modernPenta.5412ed3607fcc430f3cad4433e512266.svg";
export { ForwardRef as ReactComponent };